module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/sonthebys-eda23e76c4c11b270a92b13bef589aec.png";